import {EnvironmentAdmin} from 'compob2b-libs';

export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = false;
  serverPicturesPath = 'https://dinastiapim.ru/pictures';
  serverDocumentsPath = 'https://dinastiapim.ru/documents';
  serverApi =  'https://dinastiapim.ru/api/v1';
  serverUrl =  'https://dinastiapim.ru';
  impersonatePortalPath = 'https://dinastiapim.ru/cabinet/dashboard';
  accessRolesCatalog = true;
}

export const environment = new EnvironmentAdminProd();
